const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  mainContainerLoading: (state) => state.app.mainContainerLoading,
  userId: (state) => state.user.userId,
  isLogin: (state) => !!state.user.userId,
  avatar: (state) => state.user.avatar,
  userName: (state) => state.user.userName,
  selectCountry: (state) => state.user.selectCountry,
};
export default getters;
